/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingInsoleStockQuantityDetails } from '../../models/thermoforming-insole-stock-quantity-details';

export interface MgmtThermoformingInsoleStockControllerGetQuantityDetails$Params {
  id: number;
}

export function mgmtThermoformingInsoleStockControllerGetQuantityDetails(http: HttpClient, rootUrl: string, params: MgmtThermoformingInsoleStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStockQuantityDetails>> {
  const rb = new RequestBuilder(rootUrl, mgmtThermoformingInsoleStockControllerGetQuantityDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsoleStockQuantityDetails>;
    })
  );
}

mgmtThermoformingInsoleStockControllerGetQuantityDetails.PATH = '/api/mgmt/thermoforming-insole-stock/{id}/quantity-details';
